import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getCarePlanRows } from "./care-plan-rows";

export const metadata = {
  tableType: "CarePlan",
  displayName: "Care Plans",
  getRows: (bundle: FhirBundleSdk) => getCarePlanRows({ bundle }),
  getSearchableText: (row: Record<string, unknown>) => {
    // Extract searchable text from care plan row
    // Exclude: originalData, id, complex objects (practitioner, organization, location, conditions)
    const searchableFields = [
      "description",
      "practitionerName",
      "locationDetails",
      "authorOrganizationDetails",
      "date",
    ];

    const rowValues = searchableFields
      .map(key => String(row[key] ?? ""))
      .filter(val => val && val !== "-")
      .join(" ");

    return rowValues.toLowerCase();
  },
};
